<template>
  <div class="card">
    <div class="card-heading">
      <h5 class="card-title">Metrics</h5>
    </div>
    <div class="card-body">
      <dl>
        <dt>Average Call Attempts</dt><dd>{{report.call_attempts.median}}</dd>
        <dt>Average Time to Answer</dt><dd>{{report.time_to_answer.median}}</dd>
        <template v-for="region in report.regions">
          <dt v-bind:key="region.key + Math.random(region.value)">Calls for {{region.key}} region</dt><dd v-bind:key="region.key">{{region.value}}</dd>
        </template>
      </dl>
      <div class="progress">
        <div class="progress-bar bg-success" role="progressbar" :style="{'width': report.percentage_calls_answered +'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          {{report.percentage_calls_answered}}% of calls answered
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MetricCallLogs',
  props: [
    'report'
  ]
}
</script>

<style scoped src='../assets/stylesheet/incoming-calls.css'></style>



// WEBPACK FOOTER //
// src/components/MetricCallLogs.vue